import { theme } from '@nobia/zeus-components/lib/styled'

export default {
  body: {
    bgColor: '#F2E9DB',
    color: '#31261D',
  },
  section: {
    bgColor: '#E4D4C4',
    color: '#31261D',
    fontSize: '26px',
    fontWeight: '500',
  },
  header: {
    maxWidth: '985px',
  },
  banner: {
    color: '#E4D4C4',
    bgColor: '#31261D',
  },
  tooltip: {
    color: '#FBF9F6',
    bgColor: '#31261D',
    fontSize: '24px'
  },
  card: {
    border: {
      selected: '#C3B5A7',
      default: '#F2E9DB',
    },
  },
  font: {
    headings: {
      fontFamily: 'Reckless Neue, serif',
      fontWeight: '350',
      title: {
        fontSizeSm: '30px',
        lineHeightSm: '36px',
        fontSizeLg: '56px',
        lineHeightLg: '60px',
        wrap: 'normal',
        margin: '10px 0 20px'
      },
    },
    preamble: {
      fontFamily: 'Lausanne, serif',
      lineHeight: '36px',
      fontWeight: '250'
    },
    paragraph: {
      fontFamily: 'Lausanne, serif',
      lineHeight: '24px',
    },
  },
  button: {
    fontWeight: '350',
    padding: '12px 30px',
  },
  costSummary: {
    totalCost: {
      fontSize: '18px',
    },
    link: {
      fontSize: '13px',
    },
  },
  email: {
    bgColor: '#F2E9DB',
    minHeight: '55px',
    label: {
      fontSize: '16px',
    },
    error: {
      height: 'auto',
      color: '#872E2E',
    },
    input: {
      bgColor: '#fbf9f6',
      border: '1px solid #C3B5A7',
    },
    wrapper: {
      minWidth: '400px',
    },
    padding: '30px',
  },
  badaPromo: {
    image: {
      maxWidth: '460px',
    },
    wrapper: {
      padding: '80px 96px 30px',
    },
  },
  summary: {
    paddingRight: '50px',
    mobile: {
      paddingRight: '50px',
    },
  },
  input: {
    mobile: {
      marginLeft: '20px',
    },
    select: {
      bgColor: theme('colors.white'),
    },
    borderColor: '#C3B5A7',
  },
  colors: {
    primary: '#31261D',
    toneA: '#F2EEE5',
    banner: '#31261D',
    white: '#FBF9F6',
    button: '#1e44cb',
    badaBlock: theme('colors.white'),
  },
}
